import React from 'react';
import { 
  Search, 
  MapPin, 
  Award, 
  ChevronRight, 
  Star, 
  ArrowRight 
} from "lucide-react";
import { GrDocumentConfig } from "react-icons/gr";
import { MdOutlineChair, MdOpenInFull, MdAccessTime } from "react-icons/md";
import './Proiecte.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Helmet } from "react-helmet";
import mobilaCoamnda from '../assests/dulap alb mobilier comanda.jpeg'
import mobilaBucatarie from '../assests/bucatarie alba riflaje .jpeg'
import mobilaMasa from '../assests/dulap riflaje.jpeg'
import mobilaRiflaje from '../assests/riflaj perete mobila Bucuresti sector 2.jpg'
import mobilaBucatarie2 from '../assests/bucatarie neagra mobilier coamanda.jpeg'
import mobilaDormitor from '../assests/dormitor sector 2 mobila.jpg'
import mobilaRiflajdecorativ from '../assests/dulap riflaje.jpeg'



// CSS inline pentru clasele noi, respectând designul existent
const additionalStyles = `
.seo-comprehensive {
  background-color: #f9fafb;
  padding: 4rem 0;
}

.seo-comprehensive h2 {
  font-size: 1.875rem;
  font-weight: 300;
  text-align: center;
  margin-bottom: 1rem;
}

.seo-intro {
  text-align: center;
  margin-bottom: 3rem;
  font-size: 1rem;
  color: #4b5563;
  line-height: 1.6;
}

.seo-products-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  margin-bottom: 4rem;
}

.seo-product-card {
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.3s ease;
  background-color: white;
}

.seo-product-card:hover {
  box-shadow: 0 4px 14px rgba(0,0,0,0.1);
}

.seo-product-image {
  position: relative;
}

.seo-product-image img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.seo-product-content {
  padding: 1.5rem;
}

.seo-product-content h3 {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #111827;
}

.seo-product-content p {
  font-size: 0.875rem;
  color: #4b5563;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.seo-locations {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  color: #6b7280;
}

.seo-keywords {
  font-size: 0.75rem;
  color: #9ca3af;
  font-style: italic;
}

.location-offers {
  padding: 4rem 0;
  background-color: white;
}

.location-offers h2 {
  font-size: 1.875rem;
  font-weight: 300;
  text-align: center;
  margin-bottom: 1rem;
}

.location-offers-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

.location-offer-card {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  padding: 2rem;
  border-radius: 0.5rem;
}

.location-offer-card h3 {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #111827;
  font-weight: 500;
  text-align: center;
}

.offers-list {
  list-style: none;
  padding: 0;
}

.offers-list li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  color: #4b5563;
}

.seo-faq {
  background-color: #f9fafb;
  padding: 4rem 0;
}

.seo-faq h2 {
  font-size: 1.875rem;
  font-weight: 300;
  text-align: center;
  margin-bottom: 1rem;
}

.faq-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

.faq-item {
  background-color: white;
  border: 1px solid #e5e7eb;
  padding: 2rem;
  border-radius: 0.5rem;
}

.faq-item h3 {
  font-size: 1.125rem;
  margin-bottom: 0.75rem;
  color: #111827;
  font-weight: 500;
}

.faq-item p {
  font-size: 0.875rem;
  color: #4b5563;
  line-height: 1.5;
}

.seo-keywords-section {
  padding: 4rem 0;
  background-color: white;
}

.seo-keywords-section h2 {
  font-size: 1.875rem;
  font-weight: 300;
  text-align: center;
  margin-bottom: 1rem;
}

.keywords-categories {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
}

.keyword-category {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  padding: 2rem;
  border-radius: 0.5rem;
}

.keyword-category h3 {
  font-size: 1.125rem;
  margin-bottom: 1rem;
  color: #111827;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.keyword-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.keyword-tag {
  background-color: #e5e7eb;
  color: #374151;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 500;
}

.icon-small {
  width: 1rem;
  height: 1rem;
}

.divider {
  width: 4rem;
  height: 2px;
  background-color: #111827;
  margin: 0 auto 3rem auto;
}
`;

function Proiecte() {

  const projects = [
    {
      id: 1,
      title: "Mobila comanda dulap",
      category: "Dulap",
      image: mobilaCoamnda,
      description: "Design complet pentru un apartament de 3 camere.",
      area: "120m²",
      duration: "1 săptămâni",
      year: "2024"
    },
    {
      id: 2,
      title: "Mobila comanda bucatarie",
      category: "Bucatarii",
      image: mobilaBucatarie,
      description: "Mobilier care combinând eleganța clasică cu funcționalitatea modernă.",
      area: "350m²",
      duration: "1 săptămâna",
      year: "2024"
    },
    {
      id: 3,
      title: "Dulap-masa modular",
      category: "Dulap",
      image: mobilaMasa,
      description: "Dulap si masa design unic. Mobilier facut la comanda rapid si placut estetic",
      area: "800m²",
      duration: "1 săptămâna",
      year: "2025"
    },
    {
      id: 4,
      title: "Mobila coamnda - riflaje",
      category: "Hospitality",
      image: mobilaRiflaje,
      description: "Mobilier personalizat care reflectă identitatea camerei",
      area: "200m²",
      duration: "1 săptămâna",
      year: "2025"
    }
  ];

  const stats = [
    { number: "500+", label: "Proiecte Finalizate" },
    { number: "15", label: "Ani de Experiență" },
    { number: "1000+", label: "Clienți Mulțumiți" },
    { number: "4.9", label: "Rating Mediu" }
  ];

  const services = [
    { title: "Consultanță Design", description: "Oferim consultanță specializată pentru a transforma viziunea ta în realitate", icon: <GrDocumentConfig /> },
    { title: "Mobilier Personalizat", description: "Creăm piese unice, adaptate perfect spațiului și nevoilor tale", icon: <MdOutlineChair /> },
    { title: "Amenajări Complete", description: "De la concept la implementare, ne ocupăm de fiecare detaliu", icon: <MdOpenInFull /> },
    { title: "Urmărire Proiect", description: "Monitorizăm fiecare etapă pentru a asigura calitatea și respectarea termenelor", icon: <MdAccessTime />}
  ];

  // Secțiunea SEO cu produse și locații
  const seoProducts = [
    {
      title: "Mobilă Bucătărie la Comandă București",
      description: "Mobilier bucătărie la comandă sector 2, sector 3 și Voluntari. Mobilă bucătărie modernă premium cu design personalizat pentru comandă mobilă București.",
      image: mobilaBucatarie2,
      locations: ["Sector 2", "Sector 3", "Voluntari"],
      keywords: "mobilier bucătărie la comandă, mobilă bucătărie modernă, mobilier bucătărie premium"
    },
    {
      title: "Livinguri complete la Comandă București",
      description: "Paturi matrimoniale la comandă, mobilier dormitor modern sector 2, sector 3. Dormitoare complete cu pat tapitat și ladă depozitare pentru mobilă la comandă sector 2.",
      image: mobilaDormitor,
      locations: ["Sector 2", "Sector 3", "Voluntari"],
      keywords: "paturi matrimoniale la comandă, mobilier dormitor modern, pat tapitat la comandă"
    },
    {
      title: "Riflaje Decorative București",
      description: "Riflaje lemn decor Voluntari, riflaje decorative perete sector 2, mobilă living cu riflaje sector 3. Design modern pentru mobilă București Voluntari.",
      image: mobilaRiflajdecorativ,
      locations: ["Sector 2", "Sector 3", "Voluntari"],
      keywords: "riflaje decorative, riflaje lemn decor, mobilă living cu riflaje"
    }
  ];

  const locationOffers = [
    {
      area: "Sector 2 București",
      offers: [
        "Mobilă la comandă București Sector 2 preț competitiv",
        "Mobilă bucătărie la comandă sector 2 cu garanție extinsă",
        "Pat cu ladă depozitare București sector 2",
        "Mobilă living sector 2 București design modern",
        "Cât costă mobilă la comandă sector 2 București - prețuri transparente"
      ]
    },
    {
      area: "Sector 3 București",
      offers: [
        "Dormitor la comandă sector 3 București calitate premium",
        "Riflaje perete sector 3 București instalare inclusă",
        "Paturi moderne sector 3 București diverse modele",
        "Mobilă bucătărie modernă sector 3 design personalizat",
        "Oferte mobilă bucătărie la comandă sector 3 reduceri speciale"
      ]
    },
    {
      area: "Voluntari București",
      offers: [
        "Mobilă București Voluntari transport gratuit",
        "Paturi personalizate cu ladă Voluntari București",
        "Mobilă personalizată București Voluntari consultanță gratuită",
        "Mobilier bucătărie pe comandă Voluntari calitate superioară",
        "Mobilă bucătărie modernă la comandă București Voluntari"
      ]
    }
  ];

  // Categoriile de cuvinte cheie pentru SEO
  const keywordCategories = [
    {
      title: "Keyword-uri Generale",
      icon: <Search />,
      keywords: [
        "comandă mobilă bucurești",
        "mobilă la comandă sector 2", 
        "mobilă la comandă sector 3",
        "mobilă bucurești voluntari",
        "mobilier bucătărie la comandă bucurești",
        "dormitoare la comandă bucurești",
        "paturi la comandă bucurești",
        "riflaje decorativi bucurești"
      ]
    },
    {
      title: "Produse Specifice",
      icon: <MdOutlineChair />,
      keywords: [
        "mobilă bucătărie la comandă sector 2",
        "mobilă bucătărie modernă sector 3",
        "mobilier bucătărie premium voluntari",
        "paturi matrimoniale la comandă bucurești",
        "dormitoare complete la comandă sector 2",
        "mobilier dormitor modern sector 3",
        "pat tapitat la comandă bucurești",
        "riflaje lemn decor voluntari"
      ]
    },
    {
      title: "Locații și Prețuri",
      icon: <MapPin />,
      keywords: [
        "mobilă la comandă bucurești sector 2 preț",
        "dormitor la comandă sector 3 bucurești",
        "mobilier bucătărie pe comandă voluntari",
        "pat cu ladă depozitare bucurești sector 2",
        "riflaje perete sector 3 bucurești",
        "mobilă personalizată bucurești voluntari",
        "mobilă living sector 2 bucurești",
        "paturi moderne sector 3 bucurești"
      ]
    },
    {
      title: "Căutări Comerciale",
      icon: <Award />,
      keywords: [
        "cât costă mobilă la comandă sector 2 bucurești",
        "oferte mobilă bucătărie la comandă sector 3",
        "paturi personalizate cu ladă voluntari bucurești",
        "mobilă dormitor ieftină la comandă sector 2",
        "riflaje din lemn preț sector 3",
        "mobilă bucătărie modernă la comandă bucurești voluntari"
      ]
    }
  ];

  return (
    <>
<Helmet>
        <title>Comandă Mobilă București - Mobilă la Comandă Sector 2, Sector 3, Voluntari</title>
        <meta 
          name="description" 
          content="Mobilă la comandă București sector 2, sector 3, Voluntari. Mobilier bucătărie la comandă, dormitoare complete, paturi matrimoniale, riflaje decorative. Prețuri competitive, calitate premium." 
        />
        <meta 
          name="keywords" 
          content="comandă mobilă bucurești, mobilă la comandă sector 2, mobilă la comandă sector 3, mobilă bucurești voluntari, mobilier bucătărie la comandă bucurești, dormitoare la comandă bucurești, paturi la comandă bucurești, riflaje decorativi bucurești" 
        />
      </Helmet>
{/* Text ascuns pentru SEO */}
<Navbar />
      <div style={{ display: 'none' }}>
        <h1>Comandă Mobilă București - Mobilă la Comandă Sector 2, Sector 3, Voluntari</h1>
        <p>Mobilă la comandă București sector 2, sector 3 și Voluntari. Mobilier bucătărie modern, dormitoare complete, paturi matrimoniale și riflaje decorative premium.</p>
      </div>
      <style dangerouslySetInnerHTML={{ __html: additionalStyles }} />
      
      {/* Meta tags și Schema.org pentru SEO */}
      <div style={{ display: 'none' }}>
        <h1>Comandă Mobilă București - Mobilă la Comandă Sector 2, Sector 3, Voluntari</h1>
        <meta name="description" content="Mobilă la comandă București sector 2, sector 3, Voluntari. Mobilier bucătărie la comandă, dormitoare complete, paturi matrimoniale, riflaje decorative. Prețuri competitive, calitate premium." />
        <meta name="keywords" content="comandă mobilă bucurești, mobilă la comandă sector 2, mobilă la comandă sector 3, mobilă bucurești voluntari, mobilier bucătărie la comandă bucurești, dormitoare la comandă bucurești, paturi la comandă bucurești, riflaje decorativi bucurești, mobilă bucătărie la comandă sector 2, mobilă bucătărie modernă sector 3, mobilier bucătărie premium voluntari, paturi matrimoniale la comandă bucurești, dormitoare complete la comandă sector 2, mobilier dormitor modern sector 3, pat tapitat la comandă bucurești, riflaje lemn decor voluntari, riflaje decorative perete bucurești sector 2, mobilă living cu riflaje sector 3, mobilă la comandă bucurești sector 2 preț, dormitor la comandă sector 3 bucurești, mobilier bucătărie pe comandă voluntari, pat cu ladă depozitare bucurești sector 2, riflaje perete sector 3 bucurești, mobilă personalizată bucurești voluntari, mobilă living sector 2 bucurești, paturi moderne sector 3 bucurești, cât costă mobilă la comandă sector 2 bucurești, oferte mobilă bucătărie la comandă sector 3, paturi personalizate cu ladă voluntari bucurești, mobilă dormitor ieftină la comandă sector 2, riflaje din lemn preț sector 3, mobilă bucătărie modernă la comandă bucurești voluntari" />
      </div>

      <div className="page">
        {/* Breadcrumb */}
        <div className="breadcrumb">
          <div className="container breadcrumb-content">
            <span>Home</span>
            <ChevronRight className="icon-small" />
            <span className="current">Mobilă la Comandă București Sector 2, Sector 3, Voluntari</span>
          </div>
        </div>

        {/* Hero Section */}
        <section className="hero">
          <div className="container text-center">
            <h1>Mobilă la Comandă București - Sector 2, Sector 3, Voluntari</h1>
            <p>Comandă mobilă București cu <strong>mobilier bucătărie la comandă București</strong>, <strong>dormitoare la comandă București</strong> și <strong>riflaje decorativi București</strong> cu design personalizat pentru fiecare locuință.</p>
          </div>
        </section>

        {/* SECȚIUNEA SEO COMPREHENSIVĂ */}
       
        {/* Projects Section */}
        <section className="projects">
          <div className="container">
            <h2>Proiectele Noastre de Referință - Mobilă Personalizată București</h2>
            <div className="divider"></div>

            <div className="projects-grid">
              {projects.map(project => (
                <div key={project.id} className="project-card">
                  <div className="project-image">
                    <img src={project.image} alt={project.title} />
                    <span className="project-category">{project.category}</span>
                  </div>
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <div className="project-info">
                    <span>{project.area}</span>
                    <span>{project.duration}</span>
                    <span>{project.year}</span>
                  </div>
                  <div className="project-link">
                    <a href="/servicii-mobila-la-comanda-sector-2"><span>Vezi detalii</span></a>
                    <ArrowRight className="icon-small" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="services">
          <div className="container">
            <h2>Serviciile Noastre - Mobilă la Comandă București</h2>
            <div className="divider"></div>

            <div className="services-grid">
              {services.map((service, index) => (
                <div key={index} className="service-item">
                  <div className="icon">{service.icon}</div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="process">
          <div className="container">
            <h2 style={{display:'flex', justifyContent:'center', alignContent:'center', alignItems:'center'}}>Procesul Nostru de Lucru - Mobilier pe Comandă București</h2>
            <div className="divider"></div>

            <div className="process-grid">
              {[
                { step: "01", title: "Consultație", desc: "Analizăm nevoile pentru mobilă personalizată București" },
                { step: "02", title: "Design", desc: "Creăm conceptul pentru mobilier bucătărie la comandă" },
                { step: "03", title: "Producție", desc: "Fabricăm mobilierul cu atenție la detalii" },
                { step: "04", title: "Instalare", desc: "Montăm și finalizăm proiectul în sector 2, 3, Voluntari" }
              ].map((phase, index) => (
                <div key={index} className="process-item">
                  <div className="process-step">{phase.step}</div>
                  <h3>{phase.title}</h3>
                  <p>{phase.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta">
          <div className="container text-center">
            <h2>Comandă Mobilă București - Sector 2, Sector 3, Voluntari</h2>
            <p>Contactează-ne pentru <strong>mobilă la comandă București</strong> cu design personalizat. <strong>Mobilier bucătărie la comandă București</strong>, <strong>dormitoare la comandă București</strong> și <strong>riflaje decorativi București</strong> cu livrare în toată zona București.</p>
            <div className="cta-buttons">
              <button className="btn-primary"><a href="tel:+40729981434">Solicită Ofertă Mobilă</a></button>
              <button className="btn-secondary"><a href="/catalog-mobila-bucuresti">Vezi Portofoliul Complet</a></button>
            </div>
          </div>
        </section>
      </div>
       <section className="seo-comprehensive">
          <div className="container">
            <h2>Mobilă la Comandă București - Produse Premium pentru Fiecare Cameră</h2>
            <div className="divider"></div>
            
            <div className="seo-intro">
              <p>Specializați în <strong>comandă mobilă București</strong>, oferim soluții complete pentru <strong>mobilă la comandă sector 2</strong>, <strong>mobilă la comandă sector 3</strong> și <strong>mobilă București Voluntari</strong>. Mobilierul nostru personalizat include <strong>mobilier bucătărie la comandă București</strong>, <strong>dormitoare la comandă București</strong>, <strong>paturi la comandă București</strong> și <strong>riflaje decorativi București</strong> cu design modern și funcțional.</p>
            </div>

            <div className="seo-products-grid">
              {seoProducts.map((product, index) => (
                <div key={index} className="seo-product-card">
                  <div className="seo-product-image">
                    <img src={product.image} alt={product.title} />
                  </div>
                  <div className="seo-product-content">
                    <h3>{product.title}</h3>
                    <p>{product.description}</p>
                    <div className="seo-locations">
                      <MapPin className="icon-small" />
                      <span>Disponibil în: {product.locations.join(', ')}</span>
                    </div>
                    <div className="seo-keywords">
                      <small>{product.keywords}</small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* SECȚIUNEA CUVINTE CHEIE SEO */}
        <section className="seo-keywords-section">
          <div className="container">
            <h2>Servicii Mobilă la Comandă București - Toate Zonele</h2>
            <div className="divider"></div>

            <div className="keywords-categories">
              {keywordCategories.map((category, index) => (
                <div key={index} className="keyword-category">
                  <h3>
                    {category.icon}
                    {category.title}
                  </h3>
                  <div className="keyword-list">
                    {category.keywords.map((keyword, keywordIndex) => (
                      <span key={keywordIndex} className="keyword-tag">
                        {keyword}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* SECȚIUNEA OFERTE PE LOCAȚII */}
        <section className="location-offers">
          <div className="container">
            <h2>Oferte Mobilă la Comandă pe Zone București</h2>
            <div className="divider"></div>

            <div className="location-offers-grid">
              {locationOffers.map((location, index) => (
                <div key={index} className="location-offer-card">
                  <h3>{location.area}</h3>
                  <ul className="offers-list">
                    {location.offers.map((offer, offerIndex) => (
                      <li key={offerIndex}>
                        <Star className="icon-small" />
                        <span>{offer}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* SECȚIUNEA FAQ SEO */}
        <section className="seo-faq">
          <div className="container">
            <h2>Întrebări Frecvente - Mobilă la Comandă București</h2>
            <div className="divider"></div>

            <div className="faq-grid">
              <div className="faq-item">
                <h3>Cât costă mobilă la comandă sector 2 București?</h3>
                <p>Prețurile pentru <strong>mobilă la comandă București sector 2</strong> variază în funcție de complexitate, materiale și dimensiuni. Oferim <strong>mobilă dormitor ieftină la comandă sector 2</strong> cu prețuri competitive și calitate garantată pentru <strong>comandă mobilă București</strong>.</p>
              </div>
              
              <div className="faq-item">
                <h3>Aveți oferte mobilă bucătărie la comandă sector 3?</h3>
                <p>Da, avem <strong>oferte mobilă bucătărie la comandă sector 3</strong> cu reduceri speciale. <strong>Mobilă bucătărie modernă sector 3</strong> cu design personalizat și materiale premium la prețuri avantajoase pentru <strong>mobilier bucătărie la comandă București</strong>.</p>
              </div>

              <div className="faq-item">
                <h3>Oferiți paturi personalizate cu ladă Voluntari București?</h3>
                <p>Realizăm <strong>paturi personalizate cu ladă Voluntari București</strong> și <strong>paturi matrimoniale la comandă București</strong> cu soluții inteligente de depozitare. <strong>Pat tapitat la comandă București</strong> în diverse stiluri pentru <strong>mobilă București Voluntari</strong>.</p>
              </div>

              <div className="faq-item">
                <h3>Cât costă riflaje din lemn preț sector 3?</h3>
                <p><strong>Riflaje din lemn preț sector 3</strong> începe de la prețuri accesibile. Oferim <strong>riflaje decorative perete București sector 2</strong> și <strong>riflaje lemn decor Voluntari</strong> cu montaj inclus pentru <strong>riflaje decorativi București</strong>.</p>
              </div>

              <div className="faq-item">
                <h3>Livrați mobilier bucătărie pe comandă Voluntari?</h3>
                <p>Da, asigurăm <strong>mobilier bucătărie pe comandă Voluntari</strong> cu transport gratuit. <strong>Mobilier bucătărie premium Voluntari</strong> cu instalare profesională și garanție extinsă pentru <strong>mobilă personalizată București Voluntari</strong>.</p>
              </div>

              <div className="faq-item">
                <h3>Aveți mobilă living sector 2 București?</h3>
                <p>Oferim <strong>mobilă living sector 2 București</strong> cu design modern și <strong>mobilă living cu riflaje sector 3</strong>. Mobilier living personalizat pentru <strong>mobilă la comandă sector 3</strong> cu soluții de depozitare inteligente.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="stats">
          <div className="container stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </section>
      <Footer />
    </>
  );
}

export default Proiecte;